// Standard piece weights (grams, edible portion) for foods that people
// naturally count in pieces. s/m/l = small/medium/large specimen.
const PIECE_FOODS = [
  { re: /\bapfel\b|äpfel|apple|mela\b|mele\b|pomme/i, w: { s: 120, m: 180, l: 240 } },
  { re: /banane|banana|banan\b/i, w: { s: 90, m: 120, l: 150 } },
  { re: /avocado|avocat/i, w: { s: 100, m: 140, l: 180 } },
  { re: /\bei\b|\beier\b|\begg(s)?\b|uovo|uova|œuf|oeuf/i, w: { s: 53, m: 60, l: 68 } },
  { re: /zwiebel|onion|cipolla|oignon/i, w: { s: 70, m: 110, l: 150 } },
  { re: /tomate\b|tomaten|tomato|pomodor|tomate/i, w: { s: 70, m: 120, l: 180 } },
  { re: /kartoffel|potato|patata|pomme de terre/i, w: { s: 80, m: 120, l: 180 } },
  { re: /karotte|möhre|carrot|carota|carotte/i, w: { s: 50, m: 80, l: 120 } },
  { re: /paprika|bell pepper|peperone|poivron/i, w: { s: 100, m: 150, l: 200 } },
  { re: /orange\b|arancia|orangen/i, w: { s: 130, m: 180, l: 230 } },
  { re: /birne|pear\b|pera\b|poire/i, w: { s: 120, m: 160, l: 200 } },
  { re: /kiwi/i, w: { s: 60, m: 75, l: 90 } },
  { re: /pfirsich|peach|pesca\b|pêche/i, w: { s: 110, m: 150, l: 190 } },
  { re: /zucchini|courgette/i, w: { s: 150, m: 200, l: 300 } },
  { re: /gurke|cucumber|cetriolo|concombre/i, w: { s: 200, m: 300, l: 400 } },
  { re: /zitrone|lemon|limone|citron/i, w: { s: 60, m: 85, l: 110 } },
  { re: /mandarine|mandarin|clementine|clementina/i, w: { s: 60, m: 75, l: 90 } },
  { re: /aprikose|apricot|albicocca|abricot/i, w: { s: 35, m: 45, l: 60 } },
  { re: /champignon|mushroom|fungo|funghi/i, w: { s: 15, m: 20, l: 30 } },
  { re: /brötchen|bread roll|panino|petit pain|semmel|weggli/i, w: { s: 45, m: 60, l: 80 } },
  // Everyday portions (slice / cup / spoon / piece)
  { re: /brot\b|brotscheibe|toast|bread\b|pane\b|pain\b|vollkornbrot|weissbrot|weißbrot|ruchbrot/i, w: { s: 25, m: 40, l: 55 } },
  { re: /joghurt|yogurt|yaourt|jogurt|skyr/i, w: { s: 125, m: 180, l: 250 } },
  { re: /quark\b|hüttenkäse|cottage cheese|ricotta|fiocchi di latte/i, w: { s: 100, m: 150, l: 250 } },
  { re: /käsescheibe|cheese slice|käse\b|formaggio|fromage/i, w: { s: 20, m: 30, l: 45 } },
  { re: /schinken|ham\b|prosciutto|jambon|wurst\b|salami|aufschnitt/i, w: { s: 15, m: 25, l: 40 } },
  { re: /mozzarella/i, w: { s: 100, m: 125, l: 150 } },
  { re: /knäckebrot|crispbread|cracker|galette/i, w: { s: 8, m: 12, l: 18 } },
  { re: /reiswaffel|rice cake|gallette di riso/i, w: { s: 7, m: 9, l: 12 } },
  { re: /müsliriegel|riegel\b|granola bar|protein bar|proteinriegel|barretta|barre\b/i, w: { s: 25, m: 40, l: 60 } },
  { re: /nüsse|nuss\b|handvoll|nuts\b|noci\b|mandeln|almonds|walnüsse|cashew/i, w: { s: 15, m: 25, l: 40 } },
  { re: /schokolade|chocolate|cioccolato|chocolat/i, w: { s: 5, m: 10, l: 20 } },
  { re: /keks\b|kekse|cookie|biscotto|biscotti|biscuit|guetzli/i, w: { s: 8, m: 12, l: 25 } },
  { re: /croissant|gipfeli|cornetto/i, w: { s: 45, m: 60, l: 80 } },
  { re: /honig|honey|miele|miel\b|konfitüre|marmelade|jam\b|marmellata|confiture/i, w: { s: 10, m: 20, l: 30 } },
  { re: /erdnussbutter|peanut butter|nussmus|mandelmus/i, w: { s: 10, m: 15, l: 30 } },
  { re: /butter\b|margarine|burro\b|beurre/i, w: { s: 5, m: 10, l: 20 } },
  { re: /olivenöl|öl\b|olive oil|olio\b|huile/i, w: { s: 5, m: 10, l: 15 } },
  { re: /tortilla|wrap\b|piadina|fladenbrot/i, w: { s: 40, m: 65, l: 90 } },
  { re: /pizza\b/i, w: { s: 250, m: 350, l: 450 } },
  { re: /erdbeere|strawberry|fragol|fraise/i, w: { s: 10, m: 15, l: 25 } },
  { re: /dattel|date\b|datter|dattero|datte\b/i, w: { s: 7, m: 9, l: 12 } },
  { re: /traube|grape|uva\b|raisin\b/i, w: { s: 4, m: 6, l: 8 } },
  { re: /feige|fig\b|fico\b|figue/i, w: { s: 35, m: 50, l: 70 } },
  { re: /pflaume|plum\b|prugna|zwetschge|prune\b/i, w: { s: 40, m: 55, l: 75 } },
  { re: /nektarine|nectarine|nettarina/i, w: { s: 110, m: 140, l: 180 } },
  { re: /mango\b|mangue/i, w: { s: 150, m: 200, l: 300 } },
  { re: /knoblauchzehe|knoblauch|garlic|aglio|ail\b/i, w: { s: 3, m: 5, l: 8 } },
  { re: /frühlingszwiebel|spring onion|scalogno|cipollotto|échalote|schalotte/i, w: { s: 10, m: 15, l: 25 } },
  { re: /brokkoli|broccoli|blumenkohl|cauliflower|cavolfiore|chou-fleur/i, w: { s: 250, m: 400, l: 600 } },
  { re: /maiskolben|corn cob|pannocchia/i, w: { s: 150, m: 200, l: 280 } },
];

export const pieceInfoFor = (name) => {
  const n = String(name || "");
  const hit = PIECE_FOODS.find((f) => f.re.test(n));
  return hit ? hit.w : null;
};

export const PIECE_FRACTIONS = [
  { label: "¼", value: 0.25 },
  { label: "½", value: 0.5 },
  { label: "¾", value: 0.75 },
  { label: "1", value: 1 },
  { label: "1½", value: 1.5 },
  { label: "2", value: 2 },
];
